import React from "react";
import {StyleContent, StyledNavigation, StyledNavItem, StyledTable} from "./styled";

interface IProps {
    children?: React.ReactNode;
    // className?: string;
}

function Tab({children}: IProps) {
    return (
        <StyledTable>
            {children}
        </StyledTable>
    )
}

interface IPropsNavigation {
    children?: React.ReactNode;
    // className?: string;
}

Tab.Navigation = ({children}: IPropsNavigation) => {
    return (<StyledNavigation>
        {children}
    </StyledNavigation>);
}

interface IPropsNavItem {
    children: React.ReactNode;
    onToggle: (e: any) => void;
    isActive: boolean;
}

Tab.NavItem = ({children, onToggle, isActive}: IPropsNavItem) => {

    return <StyledNavItem isActive={isActive} onClick={onToggle}>
        {children}
    </StyledNavItem>
}


interface IPropsContent {
    children?: React.ReactNode;
}

Tab.Content = ({children}: IPropsContent) => {
    return <StyleContent>
        {children}
    </StyleContent>
}


export default Tab;